import { lazyRouteComponent } from '@tanstack/react-router';

export const onboardingPageLoadable = lazyRouteComponent(() =>
  import('../../ui/onboarding-page').then((m) => ({
    default: m.OnboardingPage,
  })),
);
